import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/PostCharge/";
    return {
        GetPostChargeViewModel(request) {
            var url = baseUrl + "GetPostChargeViewModel";
            return Proxy.Post(url, request);
        },
        SubmitPostCharge(request) {
            var url = baseUrl + "SubmitPostCharge";
            return Proxy.Post(url, request);
        },
    };
})()